'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function both(condition1, condition2, arg) {
  return !!(condition1(arg) && condition2(arg));
}

/**
 * Returns `true` if the results of `arg` applied to both `condition1` and
 * `condition2` are truthy.
 *
 * @example
 * const isOneToTen = both(
 *   n => n >= 1,
 *   n => n <= 10
 * );
 *
 * isOneToTen(3) === true;
 * isOneToTen(11) === false;
 *
 * @param {Function} condition1
 * @param {Function} condition2
 * @return {boolean}
 */
exports.default = (0, _curry2.default)(both);
module.exports = exports['default'];